import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Checkbox,
  Grid,
  ListItemText,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { Root, classes } from './utils';
import { lightPalette } from '../../../theme';
import UsersPieChart from './UsersPieChart';
import CreditsBarChart from './CreditsBarChart';
import ActivityHistoryGeneralDashboard from './ActivityHistoryGeneralDashboard';
import UploadExportHistoryBarChart from './UploadExportHistoryBarChart';
import FlowConfigurationDetailsAndChart from './FlowConfigurationDetailsAndChart';
import ValidateDocChart from './ValidateDocChart';
import CardComponentGrid from './CardComponentGrid';
import TotalDocumentCardGrid from './TotalDocumentCardGrid';
import PlanDetailsDashboard from './PlanDetailsDashboard';
import Toast from '../utils/Toast';

const AdminDashboardNew = () => {
  const documentTypeOptions = [
    { title: 'Bank Statement', type: 'BS' },
    { title: 'Credit Card Statement', type: 'CC' },
    { title: 'Sales', type: 'sales' },
    { title: 'Direct Expenses', type: 'invoice' },
    { title: 'Indirect Expenses', type: 'receipt' },
  ];
  const [documentTypeSelection, setDocumentTypeSelection] = useState([
    'Bank Statement',
    'Credit Card Statement',
    'Sales',
    'Direct Expenses',
    'Indirect Expenses',
  ]);

  const filteredTypes = documentTypeOptions
    ?.filter((option) => documentTypeSelection?.includes(option.title))
    ?.map((option) => option.type);

  const getTypeByTitle = (title) => {
    const found = documentTypeOptions.find((option) => option.title === title);
    return found ? [found.type] : [];
  };
  const selectedDashboardType = 'together';

  // --------------- this is commented because of further use for filter buttons ---------------
  // const [selectedDashboardType, setSelectedDashboardType] = useState('together');

  // const handleSelectedDashboardTypeToggle = (button) => {
  //   setSelectedDashboardType(button);
  // };

  const handleDocumentTypeSelectionChange = (event) => {
    const selected = event.target.value;
    if (selected.length === 0) {
      Toast({
        message: 'At least one option must be selected.!',
        variant: 'warning',
      });
      return;
    }
    setDocumentTypeSelection(selected);
  };

  const getCommaSeparatedValues = () => {
    let displayString = documentTypeSelection
      ?.map((option) => option)
      .join(', ');
    const maxDisplayLength = 50;
    if (displayString.length > maxDisplayLength) {
      displayString = `${displayString.slice(0, maxDisplayLength)}...`;
    }
    return displayString;
  };

  return (
    <Root className={classes.root}>
      <Box className={classes.dashboardHeader}>
        <Box className={classes.dashboardHeaderContent}>
          <Box className={classes.dashboardHeaderLeft}>
            <Typography variant="h6" className={classes.dashboardTitle}>
              Dashboard
            </Typography>
            <Box className={classes.documentTypeSelectWrapper}>
              <Select
                className={classes.documentTypeSelectionDropdown}
                multiple
                value={documentTypeSelection}
                onChange={handleDocumentTypeSelectionChange}
                renderValue={() => (
                  <Box
                    sx={{
                      color: lightPalette.darkPurple.main,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {getCommaSeparatedValues()}
                  </Box>
                )}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 280,
                    },
                  },
                }}
              >
                {documentTypeOptions.map((option) => (
                  <MenuItem
                    sx={{
                      '&.Mui-selected': {
                        backgroundColor: lightPalette.primary.lighter,
                        color: lightPalette.secondaryBlack.main,
                      },
                      '&.Mui-selected:hover': {
                        backgroundColor: lightPalette.primary.medium,
                        color: lightPalette.secondaryBlack.main,
                      },
                    }}
                    key={option.title}
                    value={option.title}
                  >
                    <Checkbox
                      checked={documentTypeSelection.includes(option.title)}
                    />
                    <ListItemText primary={option.title} />
                  </MenuItem>
                ))}
              </Select>
            </Box>
          </Box>
          {/* <Box className={classes.dashboardHeaderRight}>
            <Button
              variant={selectedDashboardType === 'together' ? 'contained' : 'outlined'}
              onClick={() => handleSelectedDashboardTypeToggle('together')}
              className={classes.dashboardTypeFilterButtonLeft}
            >
              <Typography
                variant="body1"
                sx={{
                  color: selectedDashboardType === 'together'
                    ? lightPalette.secondaryWhite.main : lightPalette.darkPurple.darker,
                }}
              >
                Together
              </Typography>
            </Button>
            <Button
              variant={selectedDashboardType === 'compare' ? 'contained' : 'outlined'}
              onClick={() => handleSelectedDashboardTypeToggle('compare')}
              // disabled
              className={classes.dashboardTypeFilterButtonRight}
            >
              <Typography
                variant="body1"
                sx={{
                  color: selectedDashboardType === 'compare'
                    ? lightPalette.secondaryWhite.main : lightPalette.darkPurple.darker,
                }}
              >
                Compare
              </Typography>
            </Button>
          </Box> */}
        </Box>
      </Box>
      <Box className={classes.mainBox}>
        <Box className={classes.mainBoxDashboardArea}>
          <Box className={classes.generalDetailsSectionMain}>
            <Box className={classes.generalDetailsSectionMainTitleBox}>
              <Typography variant="h6" className={classes.dashboardTitle}>
                General Details
              </Typography>

              <PlanDetailsDashboard />
            </Box>

            <Grid
              container
              rowGap={{ xs: 2, lg: 0 }}
              className={classes.dashboardGDMainGrid}
            >
              <Grid
                item
                xs={12}
                sm={5.8}
                md={5.8}
                lg={3.5}
                xl={3}
                className={classes.dashboardGDMainGridMainContainers}
              >
                <Grid
                  container
                  className={classes.dashboardGDMainGridMainContainersSection}
                >
                  <Grid
                    item
                    xs={12}
                    className={classes.dashboardGDSectionTitle}
                  >
                    <Typography
                      variant="body1"
                      className={classes.dashboardTitle}
                    >
                      Users
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.dashboardGDSectionMain}>
                    <UsersPieChart />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={6}
                lg={3.5}
                xl={3.8}
                className={classes.dashboardGDMainGridMainContainers}
              >
                <Grid
                  container
                  className={classes.dashboardGDMainGridMainContainersSection}
                >
                  <Grid
                    item
                    xs={12}
                    className={classes.dashboardGDSectionTitle}
                  >
                    <Typography
                      variant="body1"
                      className={classes.dashboardTitle}
                    >
                      Credits Available
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.dashboardGDSectionMain}>
                    <CreditsBarChart />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={4.8}
                xl={5}
                className={classes.dashboardGDMainGridMainContainers}
              >
                <Grid
                  container
                  className={classes.dashboardGDMainGridMainContainersSection}
                >
                  <Grid
                    item
                    xs={12}
                    className={classes.dashboardGDSectionTitle}
                  >
                    <Typography
                      variant="body1"
                      className={classes.dashboardTitle}
                    >
                      Activity History
                    </Typography>
                  </Grid>
                  <Grid item xs={12} className={classes.dashboardGDSectionMain}>
                    <ActivityHistoryGeneralDashboard />

                    <Box className={classes.ahNavigationButton}>
                      <Link
                        to="/account-info?tab=activityHistory"
                        style={{
                          color: lightPalette.deepAmethyst.semiDark,
                        }}
                      >
                        View More History
                      </Link>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>
        {selectedDashboardType === 'compare' ? (
          documentTypeSelection?.map((item, index) => (
            <Box key={`${index + 1}`} className={classes.mainBoxDashboardArea}>
              <Box className={classes.documentTypeSectionMain}>
                <Box
                  className={classes.dashboardDocumentTypeSectionMainTitleBox}
                >
                  <Typography variant="h6" className={classes.dashboardTitle}>
                    {item}
                  </Typography>
                </Box>

                <Grid
                  container
                  rowGap={{ xs: 2 }}
                  columnGap={{ xs: 1 }}
                  className={classes.dashboardDocumentTypeMainGrid}
                >
                  <CardComponentGrid
                    itemName={item}
                    selectedDashboardType={selectedDashboardType}
                    filteredTypes={filteredTypes}
                    getTypeByTitle={getTypeByTitle}
                  />

                  <Grid
                    item
                    xs={12}
                    md={5.9}
                    lg={5.91}
                    xl={5.95}
                    className={classes.dashboardDocumentTypeMainGridUHContainer}
                  >
                    <Grid
                      container
                      className={classes.dashboardDTMainGridUHContainerSection}
                    >
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTUploadExportSectionTitle}
                      >
                        <Typography
                          variant="h5"
                          className={classes.dashboardDTTitle}
                        >
                          Upload History
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTUploadExportSectionMain}
                      >
                        <UploadExportHistoryBarChart
                          mainKey="Upload"
                          itemName={item}
                          selectedDashboardType={selectedDashboardType}
                          filteredTypes={filteredTypes}
                          getTypeByTitle={getTypeByTitle}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={5.9}
                    lg={5.91}
                    xl={5.95}
                    className={classes.dashboardDocumentTypeMainGridEHContainer}
                  >
                    <Grid
                      container
                      className={classes.dashboardDTMainGridEHContainerSection}
                    >
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTUploadExportSectionTitle}
                      >
                        <Typography
                          variant="h5"
                          className={classes.dashboardDTTitle}
                        >
                          Export History
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTUploadExportSectionMain}
                      >
                        <UploadExportHistoryBarChart
                          mainKey="Export"
                          itemName={item}
                          selectedDashboardType={selectedDashboardType}
                          filteredTypes={filteredTypes}
                          getTypeByTitle={getTypeByTitle}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    md={5.9}
                    lg={5.91}
                    xl={5.95}
                    className={classes.dashboardDocumentTypeMainGridFCContainer}
                  >
                    <Grid
                      container
                      className={classes.dashboardDTMainGridFCContainerSection}
                    >
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTFlowSectionTitle}
                      >
                        <Typography
                          variant="h5"
                          className={classes.dashboardDTTitle}
                        >
                          Flow Configuration
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTFlowSectionMain}
                      >
                        <FlowConfigurationDetailsAndChart
                          itemName={item}
                          selectedDashboardType={selectedDashboardType}
                          filteredTypes={filteredTypes}
                          getTypeByTitle={getTypeByTitle}
                        />

                        <Box className={classes.fcNavigationButton}>
                          <Link
                            to="/flow-configuration"
                            style={{
                              color: lightPalette.deepAmethyst.semiDark,
                            }}
                          >
                            View More
                          </Link>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={5.9}
                    md={2.85}
                    lg={2.85}
                    xl={2.925}
                    className={classes.dashboardDocumentTypeMainGridVDContainer}
                  >
                    <Grid
                      container
                      className={classes.dashboardDTMainGridVDContainerSection}
                    >
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTValidateSectionTitle}
                      >
                        <Typography
                          variant="h5"
                          className={classes.dashboardDTTitle}
                        >
                          Validate Document
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        className={classes.dashboardDTValidateSectionMain}
                      >
                        <ValidateDocChart
                          itemName={item}
                          selectedDashboardType={selectedDashboardType}
                          filteredTypes={filteredTypes}
                          getTypeByTitle={getTypeByTitle}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={5.9}
                    md={2.85}
                    lg={2.85}
                    xl={2.925}
                    className={classes.dashboardDocumentTypeMainGridTDContainer}
                  >
                    <Grid
                      container
                      className={classes.dashboardDTMainGridTDContainerSection}
                    >
                      <TotalDocumentCardGrid
                        itemName={item}
                        selectedDashboardType={selectedDashboardType}
                        filteredTypes={filteredTypes}
                        getTypeByTitle={getTypeByTitle}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          ))
        ) : (
          <Box className={classes.mainBoxDashboardArea}>
            <Box className={classes.documentTypeSectionMain}>
              <Box className={classes.dashboardDocumentTypeSectionMainTitleBox}>
                <Typography variant="h6" className={classes.dashboardTitle}>
                  Together Documents
                </Typography>
              </Box>

              <Grid
                container
                rowGap={{ xs: 2 }}
                columnGap={{ xs: 1 }}
                className={classes.dashboardDocumentTypeMainGrid}
              >
                <CardComponentGrid
                  selectedDashboardType={selectedDashboardType}
                  filteredTypes={filteredTypes}
                  getTypeByTitle={getTypeByTitle}
                />

                <Grid
                  item
                  xs={12}
                  md={5.9}
                  lg={5.91}
                  xl={5.95}
                  className={classes.dashboardDocumentTypeMainGridUHContainer}
                >
                  <Grid
                    container
                    className={classes.dashboardDTMainGridUHContainerSection}
                  >
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTUploadExportSectionTitle}
                    >
                      <Typography
                        variant="h5"
                        className={classes.dashboardDTTitle}
                      >
                        Upload History
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTUploadExportSectionMain}
                    >
                      <UploadExportHistoryBarChart
                        mainKey="Upload"
                        selectedDashboardType={selectedDashboardType}
                        filteredTypes={filteredTypes}
                        getTypeByTitle={getTypeByTitle}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={5.9}
                  lg={5.91}
                  xl={5.95}
                  className={classes.dashboardDocumentTypeMainGridEHContainer}
                >
                  <Grid
                    container
                    className={classes.dashboardDTMainGridEHContainerSection}
                  >
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTUploadExportSectionTitle}
                    >
                      <Typography
                        variant="h5"
                        className={classes.dashboardDTTitle}
                      >
                        Export History
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTUploadExportSectionMain}
                    >
                      <UploadExportHistoryBarChart
                        mainKey="Export"
                        selectedDashboardType={selectedDashboardType}
                        filteredTypes={filteredTypes}
                        getTypeByTitle={getTypeByTitle}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={5.9}
                  lg={5.91}
                  xl={5.95}
                  className={classes.dashboardDocumentTypeMainGridFCContainer}
                >
                  <Grid
                    container
                    className={classes.dashboardDTMainGridFCContainerSection}
                  >
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTFlowSectionTitle}
                    >
                      <Typography
                        variant="h5"
                        className={classes.dashboardDTTitle}
                      >
                        Flow Configuration
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTFlowSectionMain}
                    >
                      <FlowConfigurationDetailsAndChart
                        selectedDashboardType={selectedDashboardType}
                        filteredTypes={filteredTypes}
                        getTypeByTitle={getTypeByTitle}
                      />
                      <Box className={classes.fcNavigationButton}>
                        <Link
                          to="/flow-configuration"
                          style={{
                            color: lightPalette.deepAmethyst.semiDark,
                          }}
                        >
                          View More
                        </Link>
                      </Box>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={5.9}
                  md={2.85}
                  lg={2.85}
                  xl={2.925}
                  className={classes.dashboardDocumentTypeMainGridVDContainer}
                >
                  <Grid
                    container
                    className={classes.dashboardDTMainGridVDContainerSection}
                  >
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTValidateSectionTitle}
                    >
                      <Typography
                        variant="h5"
                        className={classes.dashboardDTTitle}
                      >
                        Validate Document
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={classes.dashboardDTValidateSectionMain}
                    >
                      <ValidateDocChart
                        selectedDashboardType={selectedDashboardType}
                        filteredTypes={filteredTypes}
                        getTypeByTitle={getTypeByTitle}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={5.9}
                  md={2.85}
                  lg={2.85}
                  xl={2.925}
                  className={classes.dashboardDocumentTypeMainGridTDContainer}
                >
                  <Grid
                    container
                    className={classes.dashboardDTMainGridTDContainerSection}
                  >
                    <TotalDocumentCardGrid
                      selectedDashboardType={selectedDashboardType}
                      filteredTypes={filteredTypes}
                      getTypeByTitle={getTypeByTitle}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
    </Root>
  );
};

export default AdminDashboardNew;
